import React, { useState } from 'react';
import { db } from '../Firebase';
import { collection, addDoc } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';
import { FiUser, FiPhone, FiMail, FiCalendar, FiClock, FiActivity, FiTag } from 'react-icons/fi';
import '../pages/AppointmentPage.css';

const AppointmentForm = () => {
  const location = useLocation();
  const { doctorName, specialty } = location.state || {};

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    dob: '',
    gender: 'Select Gender',
    department: specialty || 'Select Department',
    doctor: doctorName || '',
    date: '',
    time: 'Morning (9 AM - 12 PM)',
    reason: ''
  });

  const [status, setStatus] = useState(null); // null, 'sending', 'success', 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      await addDoc(collection(db, 'appointments'), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        email: formData.email,
        dob: formData.dob,
        gender: formData.gender,
        doctor: formData.doctor,
        department: formData.department,
        date: formData.date,
        time: formData.time,
        reason: formData.reason,
        createdAt: new Date().toISOString()
      });

      // Send email using formsubmit.co
      await fetch('https://formsubmit.co/ajax/swaruphospital154@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          _subject: `New Appointment Request from ${formData.firstName} ${formData.lastName}`,
          _template: 'table',
          'First Name': formData.firstName,
          'Last Name': formData.lastName,
          'Phone': formData.phone,
          'Email': formData.email || 'Not provided',
          'Date of Birth': formData.dob || 'Not provided',
          'Gender': formData.gender,
          'Department': formData.department,
          'Preferred Doctor': formData.doctor || 'Any available doctor',
          'Appointment Date': formData.date,
          'Preferred Time': formData.time,
          'Reason for Visit': formData.reason || 'Not specified',
          _autoresponse: 'Thank you for booking an appointment at Swarup Hospital. We will confirm your slot shortly.'
        })
      });

      setStatus('success');

      setFormData({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        dob: '',
        gender: 'Select Gender',
        department: 'Select Department',
        doctor: '',
        date: '',
        time: 'Morning (9 AM - 12 PM)',
        reason: ''
      });
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus('error');
    }
  };

  return (
    <form className="apt-form-wrapper" onSubmit={handleSubmit}>
      <h2 className="apt-form-title">Patient Details</h2>
      <div className="title-underline" />

      <div className="apt-grid">
        <div className="form-group-wrapper">
          <label className="apt-label">First Name</label>
          <div className="input-with-icon">
            <FiUser className="input-field-icon" />
            <input
              type="text"
              name="firstName"
              className="apt-input"
              placeholder="Enter your first name"
              required
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group-wrapper">
          <label className="apt-label">Last Name</label>
          <div className="input-with-icon">
            <FiUser className="input-field-icon" />
            <input
              type="text"
              name="lastName"
              className="apt-input"
              placeholder="Enter your last name"
              required
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="apt-grid">
        <div className="form-group-wrapper">
          <label className="apt-label">Phone Number</label>
          <div className="input-with-icon">
            <FiPhone className="input-field-icon" />
            <input
              type="tel"
              name="phone"
              className="apt-input"
              placeholder="e.g. +91 98765 43210"
              required
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group-wrapper">
          <label className="apt-label">Email Address</label>
          <div className="input-with-icon">
            <FiMail className="input-field-icon" />
            <input
              type="email"
              name="email"
              className="apt-input"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="apt-grid">
        <div className="form-group-wrapper">
          <label className="apt-label">Date of Birth</label>
          <div className="input-with-icon">
            <FiCalendar className="input-field-icon" />
            <input
              type="date"
              name="dob"
              className="apt-input"
              value={formData.dob}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group-wrapper">
          <label className="apt-label">Gender</label>
          <div className="input-with-icon">
            <FiUser className="input-field-icon" />
            <select
              name="gender"
              className="apt-select"
              value={formData.gender}
              onChange={handleChange}
            >
              <option>Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>
        </div>
      </div>

      <h2 className="apt-form-title" style={{ marginTop: '30px' }}>Appointment Details</h2>
      <div className="title-underline" />

      <div className="apt-grid">
        <div className="apt-full-width form-group-wrapper">
          <label className="apt-label">Preferred Doctor</label>
          <div className="input-with-icon">
            <FiUser className="input-field-icon" />
            <input
              type="text"
              name="doctor"
              className="apt-input"
              placeholder="Search doctor name (optional)"
              value={formData.doctor}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="apt-grid">
        <div className="apt-full-width form-group-wrapper">
          <label className="apt-label">Department</label>
          <div className="input-with-icon">
            <FiActivity className="input-field-icon" />
            <select
              name="department"
              className="apt-select"
              value={formData.department}
              onChange={handleChange}
            >
              <option>Select Department</option>
              <option>Cardiology</option>
              <option>Orthopedics</option>
              <option>Neurology</option>
              <option>Pediatrics</option>
              <option>General Medicine</option>
              <option>Gynecology</option>
              <option>Dermatology</option>
              <option>ENT</option>
            </select>
          </div>
        </div>
      </div>

      <div className="apt-grid">
        <div className="form-group-wrapper">
          <label className="apt-label">Preferred Date</label>
          <div className="input-with-icon">
            <FiCalendar className="input-field-icon" />
            <input
              type="date"
              name="date"
              className="apt-input"
              required
              value={formData.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group-wrapper">
          <label className="apt-label">Preferred Time</label>
          <div className="input-with-icon">
            <FiClock className="input-field-icon" />
            <select
              name="time"
              className="apt-select"
              value={formData.time}
              onChange={handleChange}
            >
              <option>Morning (9 AM - 12 PM)</option>
              <option>Afternoon (12 PM - 4 PM)</option>
              <option>Evening (4 PM - 8 PM)</option>
            </select>
          </div>
        </div>
      </div>

      <div className="apt-full-width form-group-wrapper" style={{ marginBottom: '25px' }}>
        <label className="apt-label">Reason for Visit / Symptoms</label>
        <div className="input-with-icon">
          <FiTag className="input-field-icon" style={{ top: '20px' }} />
          <textarea
            name="reason"
            className="apt-textarea"
            placeholder="Briefly describe your symptoms or reason for visit..."
            rows="3"
            value={formData.reason}
            onChange={handleChange}
          ></textarea>
        </div>
      </div>

      <button
        type="submit"
        className="apt-btn-submit"
        disabled={status === 'sending'}
      >
        {status === 'sending' ? 'Sending Request...' : 'Confirm Appointment'}
      </button>

      {status === 'success' && (
        <div className="apt-status-alert success">
          ✅ Appointment request sent successfully! We will contact you shortly to confirm your time slot.
        </div>
      )}

      {status === 'error' && (
        <div className="apt-status-alert error">
          ❌ Something went wrong while submitting. Please try again or call us directly at 1066.
        </div>
      )}

      <p className="apt-terms-text">
        By clicking confirm, you accept our privacy policy and terms of care.
      </p>
    </form>
  );
};

export default AppointmentForm;
